#import "@/components/common/CraftAssetFragment.gql"
#import "@/components/common/LinkFragment.gql"

fragment HeaderBlockBoxHeadingFragment on boxHeading_Entry {
  typeHandle
  heading
  course
  image {
    ...CraftAssetFragment
  }
  boxPositionRight
  cta {
    ...LinkFragment
  }
}
